import { useEffect, useState } from "react";
import { acceptUserConsent, getContactEmail, getUserConsent } from "../HTTP/user";

export default function Footer() {
    const COOKIE_NOTICE_SESSION_KEY = "cookie_notice_seen";

    const [adminEmail, setAdminEmail] = useState('contact@zemus.info')
    const [showCookiePopup, setShowCookiePopup] = useState(false);

    useEffect(() => {
        const fetchAdminEmail = async () => {
            const resAdminEmail = await getContactEmail();
            if (resAdminEmail?.value) {
                setAdminEmail(resAdminEmail.value);
            }
        }
        fetchAdminEmail();
    }, []);

    useEffect(() => {
        const checkConsent = async () => {
            const rawUser = localStorage.getItem("user");
            const currentUser = rawUser ? JSON.parse(rawUser) : null;
            const userId = currentUser?.id;

            if (!userId) {
                setShowCookiePopup(false);
                sessionStorage.removeItem(COOKIE_NOTICE_SESSION_KEY);
                return;
            }

            try {
                const consentResponse = await getUserConsent(userId);
                const hasAcceptedConsent = Number(consentResponse?.consent) === 1 || consentResponse?.accepted === true;

                if (hasAcceptedConsent) {
                    setShowCookiePopup(false);
                    sessionStorage.setItem(COOKIE_NOTICE_SESSION_KEY, "true");
                    return;
                }

                const hasSeenCookieNotice = sessionStorage.getItem(COOKIE_NOTICE_SESSION_KEY);
                if (!hasSeenCookieNotice) {
                    setShowCookiePopup(true);
                } else {
                    setShowCookiePopup(false);
                }
            } catch (error) {
                console.error("Erreur lors du chargement du consentement", error);
                const hasSeenCookieNotice = sessionStorage.getItem(COOKIE_NOTICE_SESSION_KEY);
                setShowCookiePopup(!hasSeenCookieNotice);
            }
        };

        checkConsent();
    }, []);

    const handleConsentAccept = async () => {
        const rawUser = localStorage.getItem("user");
        const currentUser = rawUser ? JSON.parse(rawUser) : null;
        const userId = currentUser?.id;

        if (!userId) {
            setShowCookiePopup(false);
            sessionStorage.setItem(COOKIE_NOTICE_SESSION_KEY, "true");
            return;
        }

        const result = await acceptUserConsent(userId);

        if (result?.accepted === true || Number(result?.consent) === 1) {
            sessionStorage.setItem(COOKIE_NOTICE_SESSION_KEY, "true");
        }

        setShowCookiePopup(false);
    };

    return (
        <>
            <footer className="lg:mt-8 text-black mb-8">
                <div className="mx-auto text-center">
                <a href="/conditions" className="text-black hover:text-zemusbis">
                    Conditions d'utilisation
                </a>
                <span className="mx-2">|</span>
                <a href="/politique" className="text-black hover:text-zemusbis">
                    Politique de confidentialité
                </a>
                <span className="mx-2">|</span>
                <a href="/legales" className="text-black hover:text-zemusbis">
                    Mentions légales
                </a>
                <span className="mx-2">|</span>
                <a href="/about" className="text-black hover:text-zemusbis">
                    A Propos
                </a>
                <span className="mx-2">|</span>
                <a href={`mailto:${adminEmail}`} className="text-black hover:text-zemusbis">
                    Contact
                </a>
                <span className="mx-2">|</span>
                <button
                    type="button"
                    onClick={() => setShowCookiePopup(true)}
                    className="text-black hover:text-zemusbis"
                >
                    Cookies
                </button>
                <span className="mx-2">|</span>
                <span className="text-black">
                    © {new Date().getFullYear()} Bivilink. Tous droits réservés.
                </span>
                </div>
            </footer>

            {showCookiePopup && (
                <div className="fixed bottom-4 left-4 z-50 max-w-sm rounded-lg border border-gray-300 bg-white p-4 shadow-xl">
                    <p className="mb-3 text-sm text-black">
                        En poursuivant votre navigation sur ce site, vous acceptez l'utilisation de cookies
                        afin d'assurer son bon fonctionnement, de mesurer l'audience et d'ameliorer votre experience.
                    </p>
                    <button
                        type="button"
                        onClick={handleConsentAccept}
                        className="rounded bg-zemusbis px-3 py-1 text-sm text-white hover:bg-zemusbis"
                    >
                        J'accepte
                    </button>
                </div>
            )}
        </>
    );
}
